"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ListingModel_1 = require("./ListingModel");
var SyncSupplier_1 = require("@twii/core/lib/model/SyncSupplier");
var ListingServiceContext_1 = require("../service/ListingServiceContext");
var ListingModelSupplier = /** @class */ (function (_super) {
    __extends(ListingModelSupplier, _super);
    function ListingModelSupplier(listingId) {
        var _this = _super.call(this) || this;
        _this._listingId = listingId;
        return _this;
    }
    Object.defineProperty(ListingModelSupplier.prototype, "listingId", {
        get: function () {
            return this._listingId;
        },
        enumerable: true,
        configurable: true
    });
    ListingModelSupplier.prototype._loadImpl = function () {
        return ListingServiceContext_1.ListingServiceContext.value.getListing({ listingId: this._listingId }).then(function (data) {
            return new ListingModel_1.ListingModel(data);
        });
    };
    return ListingModelSupplier;
}(SyncSupplier_1.SyncSupplier));
exports.ListingModelSupplier = ListingModelSupplier;
